module.exports = __webpack_public_path__ + "static/media/pt-aigfutura-book-webfont.04be92fb.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pt-aigfutura-book-webfont.ttf
// module id = 370
// module chunks = 3